<div>
  <div class="content-card">
    <h1 class="bold">{{ workerFullNameSubject | async }}</h1>
    <ul class="header__nav">
      <li class="header__item">
        <a [routerLink]="['/profile', workerId, 'contactInfo']" class="header__link">{{ 'WF-PersonalData' | translate
          }}</a>
      </li>
      <li class="header__item">
        <a [routerLink]="['/profile', workerId, 'additionalInfo']" class="header__link">{{ 'WF-AdditionalData' |
          translate }}</a>
      </li>
      <li class="header__item">
        <a [routerLink]="['/profile', workerId, 'statements']" class="header__link">{{ 'WF-Statements' | translate
          }}</a>
      </li>
      <li class="header__item">
        <a [routerLink]="['/profile', workerId, 'agreements']" class="header__link header__link--active">{{
          'WP-Agreements' | translate }}</a>
      </li>
      <li class="header__item">
        <a [routerLink]="['/profile', workerId, 'documents']" class="header__link">{{ 'WP-Documents' | translate }}</a>
      </li>
      <li class="header__item">
        <a [routerLink]="['/profile', workerId, 'timesheets']" class="header__link">{{ 'WP-Timesheets' | translate
          }}</a>
      </li>
      <li class="header__item">
        <a [routerLink]="['/profile', workerId, 'employmentHistory']" class="header__link">{{ 'WF-EmploymentHistory' |
          translate }}</a>
      </li>
      <li class="header__item">
        <a [visibleWithPermissions]="['ManageAllExternalWorkersList', 'ManageMyExternalWorkersList']"
          [routerLink]="['/profile', workerId, 'settings']" class="header__link">{{ 'WP-Settings' | translate }}</a>
      </li>
    </ul>
  </div>

  <mat-horizontal-stepper linear #stepper>
    <mat-step [stepControl]="basicInformationStepFormGroup">
      <ng-template matStepLabel>{{ 'AEF-BasicInformation' | translate }}</ng-template>
      @if (isLegalizationFieldVisible$ | async) {
      <ng-container *ngTemplateOutlet="legalization"></ng-container>
      }
      <app-basic-information-step [basicInformationStepFormGroup]="basicInformationStepFormGroup"
        [prefetchedAgreement]="prefetchedAgreement" [workerId]="workerId"
        (formGroupChange)="onBasicInformationStepChange($event)"
        (basicInformationSaved)="onBasicInformationSaved()"></app-basic-information-step>
    </mat-step>
    <mat-step [stepControl]="wageParametersStepFormGroup">
      <ng-template matStepLabel>{{ 'AEF-EmploymentConditions' | translate }}</ng-template>
      @if (isLegalizationFieldVisible$ | async) {
      <ng-container *ngTemplateOutlet="legalization"></ng-container>
      }
      <app-wage-parameters-step [wageParametersStepFormGroup]="wageParametersStepFormGroup"
        [prefetchedAgreement]="prefetchedAgreement"></app-wage-parameters-step>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ 'AEF-Insurance' | translate }}</ng-template>
      @if (isLegalizationFieldVisible$ | async) {
      <ng-container *ngTemplateOutlet="legalization"></ng-container>
      }
      <app-insurance-step [insuranceFormGroup]="insuranceStepFormGroup"
        [prefetchedAgreement]="prefetchedAgreement"></app-insurance-step>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ 'AEF-Summary' | translate }}</ng-template>
      @if (isLegalizationFieldVisible$ | async) {
      <ng-container *ngTemplateOutlet="legalization"></ng-container>
      }
      <app-summary-step [prefetchedAgreement]="prefetchedAgreement"></app-summary-step>
    </mat-step>
  </mat-horizontal-stepper>
</div>

<ng-template #legalization>
  <div
    [visibleWithPermissions]="['LegalizationInformationVisibilityToAll', 'LegalizationInformationVisibilityToEmployerObjects']">
    <div class="content-card-empty"></div>
    <div class="content-card">
      <h2 class="content-card__header">{{ 'Legalization.LegalizationStatus' | translate }}</h2>
      <div class="row">
        <div class="col-2">
          <app-legalization-status-info [element]="workerAgreementLegalizationData" [size]="'large'"
            [showStatusText]="true" [showTooltip]="false"></app-legalization-status-info>
        </div>
        <div class="col-2">
          <button mat-raised-button class="legalization-status-btn" (click)="onSubmitForLegalization()" type="button"
            [matTooltip]="'Legalization.SubmitForLegalizationInfo' | translate">
            {{ 'Legalization.SubmitForLegalization' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="content-card-empty"></div>
  </div>
</ng-template>